export const VEHICLE_NAME = "White Nissan Armada Platinum";

export const VehicleCard = ({ label = "Your vehicle", detail, testId = "vehicle-card" }) => (
  <div data-testid={testId} className="lux-card flex items-center gap-4 overflow-hidden p-3 pr-5">
    <img src="/armada-34.jpg" alt={VEHICLE_NAME} className="h-16 w-24 shrink-0 rounded-lg object-cover sm:h-20 sm:w-32" />
    <div className="min-w-0">
      <p className="lux-eyebrow">{label}</p>
      <p className="mt-1 font-serif text-base text-amber-50 sm:text-lg">{VEHICLE_NAME}</p>
      <p className="truncate text-xs text-zinc-400">{detail || "Full-size luxury SUV · up to 7 passengers"}</p>
    </div>
  </div>
);
